/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var CatalogType;
(function (CatalogType) {
    CatalogType["MARKETING_SIF"] = "MARKETING_SIF";
    CatalogType["PRICEBOOK"] = "PRICEBOOK";
    CatalogType["CET_XML"] = "CET_XML";
    CatalogType["PRODUCT_DTL_PRICE"] = "PRODUCT_DTL_PRICE";
    CatalogType["PRODUCT_DTL"] = "PRODUCT_DTL";
})(CatalogType || (CatalogType = {}));
